var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKnowledgeCenter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00001 3.125C4.42471 3.125 3.95834 3.59137 3.95834 4.16667V15.8333C3.95834 16.1785 3.67852 16.4583 3.33334 16.4583C2.98817 16.4583 2.70834 16.1785 2.70834 15.8333V4.16667C2.70834 2.90101 3.73436 1.875 5.00001 1.875H16.1667C16.788 1.875 17.2917 2.37868 17.2917 3V13.9286C17.2917 14.2737 17.0119 14.5536 16.6667 14.5536C16.3215 14.5536 16.0417 14.2737 16.0417 13.9286V3.125H5.00001Z",
    fill: "#4B5054"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.37501 14.1667C4.37501 13.8215 4.65483 13.5417 5.00001 13.5417H16.6667C17.0119 13.5417 17.2917 13.8215 17.2917 14.1667C17.2917 14.5118 17.0119 14.7917 16.6667 14.7917H5.00001C4.65483 14.7917 4.37501 14.5118 4.37501 14.1667Z",
    fill: "#4B5054"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.37501 17.5C4.37501 17.1548 4.65483 16.875 5.00001 16.875H16.6667C17.0119 16.875 17.2917 17.1548 17.2917 17.5C17.2917 17.8452 17.0119 18.125 16.6667 18.125H5.00001C4.65483 18.125 4.37501 17.8452 4.37501 17.5Z",
    fill: "#4B5054"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.62501 14.1667C5.62501 13.8215 5.34519 13.5417 5.00001 13.5417C3.73436 13.5417 2.70834 14.5677 2.70834 15.8333C2.70834 17.099 3.73436 18.125 5.00001 18.125C5.34519 18.125 5.62501 17.8452 5.62501 17.5C5.62501 17.1548 5.34519 16.875 5.00001 16.875C4.42471 16.875 3.95834 16.4086 3.95834 15.8333C3.95834 15.258 4.42471 14.7917 5.00001 14.7917C5.34519 14.7917 5.62501 14.5118 5.62501 14.1667Z",
    fill: "#4B5054"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.87501 5.83333C6.87501 5.48816 7.15483 5.20833 7.50001 5.20833H12.5C12.8452 5.20833 13.125 5.48816 13.125 5.83333C13.125 6.17851 12.8452 6.45833 12.5 6.45833H7.50001C7.15483 6.45833 6.87501 6.17851 6.87501 5.83333Z",
    fill: "#4B5054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledgeCenter);
export default __webpack_public_path__ + "static/media/knowledge-center.48336150a290fdb87457308a27edd836.svg";
export { ForwardRef as ReactComponent };